import script from "./ContentHighlightsListAppEdit.vue?vue&type=script&lang=ts&setup=true"
export * from "./ContentHighlightsListAppEdit.vue?vue&type=script&lang=ts&setup=true"

import "./ContentHighlightsListAppEdit.vue?vue&type=style&index=0&id=21613254&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21613254"]])

export default __exports__